module.exports = __webpack_public_path__ + "img/PX.4cd741cf.png";